var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEEF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 20C21.6875 19.068 20.932 18.3125 20 18.3125C19.068 18.3125 18.3125 19.068 18.3125 20C18.3125 20.932 19.068 21.6875 20 21.6875C20.932 21.6875 21.6875 20.932 21.6875 20Z",
    fill: "#B4BBCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 20C27.3125 19.068 26.557 18.3125 25.625 18.3125C24.693 18.3125 23.9375 19.068 23.9375 20C23.9375 20.932 24.693 21.6875 25.625 21.6875C26.557 21.6875 27.3125 20.932 27.3125 20Z",
    fill: "#B4BBCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 20C16.0625 19.068 15.307 18.3125 14.375 18.3125C13.443 18.3125 12.6875 19.068 12.6875 20C12.6875 20.932 13.443 21.6875 14.375 21.6875C15.307 21.6875 16.0625 20.932 16.0625 20Z",
    fill: "#B4BBCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.4eafbf21df2ed1492674e09db023de6f.svg";
export { ForwardRef as ReactComponent };